import { Box, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import { styled } from '@mui/material/styles'
import { theme } from '~/lib/theme'
import { staticPath } from '~/lib/$path'
import { CornerImages } from './CornerImages'

interface EyeCatchImageProps {
  imageSrc: string
  mobileImageSrc?: string
  altText: string
}

/**
 * EyeCatchImage コンポーネントは、メインの画像（ロゴなど）を表示するコンポーネントです。
 *
 * スクリーン幅が 'md' 以上の場合には、CornerImages コンポーネントを表示して、画面の四隅に画像を配置します。
 * スクリーン幅が 'md' 未満の場合には、モバイル用の画像（`mobileImageSrc`）を表示し、そうでない場合にはPC用の画像（`imageSrc`）を表示します。
 * 画像は中央に配置され、指定された最大幅や最大高さに基づいてスタイリングされます。
 *
 * @param {string} props.imageSrc - デフォルトの画像のソース URL。
 * @param {string} [props.mobileImageSrc] - モバイル用の画像のソース URL（省略可能）。
 * @param {string} props.altText - 画像の代替テキスト。
 */
export const EyeCatchImage: React.FC<EyeCatchImageProps> = ({ imageSrc, mobileImageSrc, altText }) => {
  const isBreakpointUpMd = useMediaQuery(theme.breakpoints.up('md'))

  const StyledImg = styled('img')`
    width: 100%;
    max-width: ${imageSrc === staticPath.signin_logo_png ? '450px' : '600px'};
    max-height: ${isBreakpointUpMd ? 'inherit' : '350px'};
    object-fit: contain;
  `

  return (
    <Box
      sx={{
        position: 'relative',
        height: '100%',
        minHeight: '100px',
        px: { xs: 3, md: 8 },
        py: { xs: 1, md: 0 },
      }}
    >
      {isBreakpointUpMd && <CornerImages />}

      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{
          height: '100%',
          textAlign: 'center',
          pt: { xs: 5, md: 0 },
        }}
      >
        <Grid item>
          <StyledImg src={isBreakpointUpMd ? imageSrc : mobileImageSrc || imageSrc} alt={altText} />
        </Grid>
      </Grid>
    </Box>
  )
}
